/**
 * 処理ステップ定義
 */

export type StepStatus = "completed" | "processing" | "error" | "pending" | "skipped" | "warning";

export interface MasterStepDefinition {
  id: string;
  name: string;
  types: string[];
  description?: string;
}

/**
 * ユーザーが期待する「一本の道」の定義
 */
export const MASTER_STEPS: MasterStepDefinition[] = [
  { id: "start", name: "バックエンド処理開始", types: ["orchestrator_start"] },
  { id: "preprocess", name: "解析用データ変換完了", types: ["ocr_preprocessing_completed"] },
  { id: "ai_setup", name: "解析準備（AI構成確認）", types: ["ocr_ai_setup"] },
  { id: "ai_processing", name: "AI解析実行中", types: ["ocr_ai_processing"] },
  { id: "ocr_complete", name: "OCR解析完了", types: ["ocr_completed"] },
  { id: "normalization_setup", name: "名寄せ設定読込", types: ["normalization_setup"] },
  { id: "normalization", name: "名称正規化", types: ["partner_normalization"] },
  { id: "identification", name: "取引先マスタ特定", types: ["partner_identified"] },
  { id: "slip_type", name: "伝票種別判定", types: ["slip_type_detection"] },
  { id: "slip_type_resolution", name: "種別名寄せ", types: ["slip_type_resolution"] },
  { id: "slip_type_config", name: "種別設定解決", types: ["slip_type_config_resolved"] },
  { id: "csv_lookup", name: "CSVテンプレート特定", types: ["csv_template_lookup"] },
  { id: "validation", name: "データバリデーション", types: ["csv_validation"] },
  { id: "csv_gen", name: "CSVファイル保存", types: ["csv_processing", "csv_generated"] },
  { id: "email_setup", name: "通知設定確認", types: ["notification_sent_setup"] },
  { id: "email_send", name: "メール送信完了", types: ["notification_sent"] },
  { id: "finish", name: "全体処理終了", types: ["process_completed", "process_failed"] },
];
